(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/imageinput/imageinput.tpl.html', [
'<div class="row">',
'  <div class="col-md-4">',
'    <label class="btn btn-primary">',
'      <span translate>imageinput.label</span>',
'      <input',
'        type="file"',
'        accept="image/*"',
'        class="image-input"',
'        style="display:none;"',
'      />',
'    </label>',
'  </div>',
'  <div class="col-md-8" ng-show="imageinput.value">',
'    <button ng-click="imageinput.delete()" class="close delete-logo">',
'      &times;',
'    </button>',
'    <img',
'      class="preview img-responsive"',
'      ng-src="data:image/jpeg;base64,{{imageinput.value}}"',
'    />',
'  </div>',
'</div>',
'',''].join("\n"));
  }]);
})();